<template>
  <div id="timeline-container">
    <LoaderComponent v-if="!loaded" />
    <div v-else id="timeline">
      <select id="timeline-country" v-model="country">
        <option selected disabled value="">Select a Country</option>
        <option
          v-for="country in countries"
          :key="country[0]"
          :value="country[0]"
        >
          {{ country[1] }}
        </option>
      </select>

      <div id="timeline-dates-container">
        <select id="timeline-start-date" v-model="start">
          <option selected disabled value="">Start Date</option>
          <option v-for="date in years" :key="date[0]" :value="date[0]">
            {{ date[1] }}
          </option>
        </select>

        <select id="timeline-end-date" v-model="end">
          <option selected disabled value="">End Date</option>
          <option v-for="date in years" :key="date[0]" :value="date[0]">
            {{ date[1] }}
          </option>
        </select>
      </div>

      <div id="timeline-go">
        <button @click="goToResults()">Go</button>
      </div>
    </div>

    <div id="timeline-description">
      <p>
        Here you will find information about historical events related to the
        items on display.
      </p>
      <div class="break"></div>

      <p>
        The Timeline is a work-in-progress and was initially set up for three
        projects only:
        <a :href="urls.islamicArt + '/'" target="_blank" class="italic"
          >Discover Islamic Art</a
        >,
        <a :href="urls.baroqueArt + '/'" target="_blank" class="italic"
          >Discover Baroque Art</a
        >, and
        <a :href="urls.sharingHistory + '/'" target="_blank" class="italic"
          >Sharing History</a
        >. The purpose was to contextualise the items on display, with the
        projects’ specific thematic focus. These texts were compiled by experts
        from each country concerned.
      </p>
      <div class="break"></div>

      <p>
        Currently, this page allows exploration of the events added to the
        Timeline for the above-mentioned projects, covering the relevant time
        ranges and participating countries.
      </p>
      <div class="break"></div>

      <p>
        On database pages, a ‘Timeline for this item’ link will display
        available events within the period of the item’s creation.
      </p>
      <div class="break"></div>

      <p>
        We are doing our best to further develop our Timeline. If you are
        willing to contribute, please contact us at
        <a :href="'mailto:' + emails.contactUs">{{ emails.contactUs }}</a
        >.
      </p>
    </div>
  </div>
</template>



<script>
import LoaderComponent from "./LoaderComponent.vue";
// Contains functions for getting timeline information
import timeline from "../mixins/timeline.js";
export default {
  name: "TimelinePage",
  components: {
    LoaderComponent: LoaderComponent,
  },
  mixins: [timeline],
  data() {
    return {
      loaded: false,
      countries: {},
      years: {},
      country: "",
      start: "",
      end: "",
      urls: {
        portal: process.env.VUE_APP_PORTAL_URL,
        baroqueArt: process.env.VUE_APP_BAROQUE_ART_URL,
        islamicArt: process.env.VUE_APP_ISLAMIC_ART_URL,
        sharingHistory: process.env.VUE_APP_SHARING_HISTORY_URL,
        galleries: process.env.VUE_APP_GALLERIES_URL,
        images: process.env.VUE_APP_IMAGES_URL,
      },
      emails: {
        contactUs: process.env.VUE_APP_CONTACT_US_EMAIL,
      },
    };
  },
  methods: {
    goToResults: function () {
      // Country required
      if (this.country === "") {
        alert("Please select a country.");
        return;
        // "All" requires start and end dates
      } else if (
        this.country === "all" &&
        (this.start === "" || this.end === "")
      ) {
        alert("Please select both a start and an end date.");
        return;
      }
      // Fill in first and last dates if only country is selected
      if (this.start === "") {
        this.start = this.years[0][0];
      }
      if (this.end === "") {
        this.end = this.years[this.years.length - 1][0];
      }
      let query = {
        c: this.country,
        start: this.start,
        end: this.end,
      };
      this.$router.push({ name: "timeline-results", query: query });
    },
  },
  mounted() {
    this.loadCountries("").then(() => {
      this.loaded = true;
    });
    this.loadYears("");
  },
};
</script>



<style scoped lang="scss">
#timeline-container {
  @include flex-center;
  align-items: flex-start;
  width: 100%;
  background-color: white;
}

.loader-container {
  min-height: 300px;
  width: 40%;
}

#timeline {
  @include flex-center;
  flex-direction: column;
  width: 40%;
  padding: 50px;
}
#timeline select {
  padding: 4px;
}
#timeline-country,
#timeline-dates-container {
  width: 100%;
  max-width: 350px;
}
#timeline-dates-container {
  @include flex-center;
  justify-content: space-between;
  margin: 15px 0;
}
#timeline-start-date,
#timeline-end-date {
  width: 48%;
}
#timeline-go button {
  @include button-styles;
  background-color: $theme-light;
  color: $light-text;
  padding: 4px 15px;
  border-radius: 100px;
}

#timeline-description {
  width: 60%;
  padding: 50px 75px 50px 0;
}
#timeline-description a {
  @include link-styles;
}
#timeline-description a:hover {
  @include link-hover-styles;
}
.break {
  padding-bottom: 15px;
}
.italic {
  font-style: italic;
}

@media only screen and (max-width: 849px) {
  #timeline-container {
    flex-direction: column;
  }
  .loader-container {
    min-height: 250px;
    width: 100%;
  }
  #timeline {
    width: 100%;
  }
  #timeline-description {
    align-self: center;
    width: 100%;
    padding: 0 50px 50px 50px;
    margin-top: 0;
  }
}

@media only screen and (max-width: 599px) {
  #timeline {
    padding: 30px;
  }
  #timeline-description {
    padding: 0 30px 30px 30px;
  }
}
</style>